// utils/redirectToLogin.ts
import { getDomainSlug } from "./domainSlug";

// Routes publiques qui ne doivent jamais déclencher une redirection vers /login
const AUTH_PUBLIC_ROUTES = ["login", "signup", "forgot-password", "reset-password", "survey-response", "campaign", "locks", "public-document", "report-export"];
const authPublicRegex = new RegExp(`^/(?:${AUTH_PUBLIC_ROUTES.join("|")})(?:/.*)?$`);

export function redirectToLogin(preservePath = true) {
    const { pathname, search } = window.location;

    // 1) Ne jamais rediriger si on est déjà sur une page d'auth publique (/login, /signup, ... ou avec slug)
    if (authPublicRegex.test(pathname)) return;

    // 2) Évite les boucles si un redirect est déjà présent
    if (/\bredirect=/.test(search)) return;

    // 3) Construit la cible à préserver
    const next = preservePath ? encodeURIComponent(pathname + search) : "";

    // 4) Détermine un éventuel slug de domaine
    const domainSlug = getDomainSlug(); // null si localhost:3000 ou peaceandwork.trigger-flow.com

    // 5) Redirection propre
    if (domainSlug) {
        window.location.href = next
            ? `/login/${encodeURIComponent(domainSlug)}?redirect=${next}`
            : `/login/${encodeURIComponent(domainSlug)}`;
    } else {
        window.location.href = next ? `/login?redirect=${next}` : `/login`;
    }
}
